import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ component: Component, scope, ...rest }) => {
  return parseInt(scope) === 3 ? <Component {...rest} /> : <Navigate to="/" />;
};

export default PrivateRoute;
